import { Button, Grid } from '@mui/material';
import axios, { AxiosError } from 'axios';
import { useCallback, useEffect, useState } from 'react';
import {
	BooleanInput,
	Edit,
	NumberInput,
	ReferenceInput,
	SelectArrayInput,
	SelectInput,
	SimpleForm,
	TextInput,
	useNotify,
	useRefresh,
} from 'react-admin';
import constants from '../../constants';
import { getLocalizedErrorMessage } from '../../utils/functions';
import VideoUploadInput from '../Inputs/VideoUploadInput';
import CreateProactiveItemCategoryDialog from './CreateProactiveItemCategoryDialog';

const ProactiveItemEdit = () => {
	const [showCreateCategoryDialog, setShowCreateCategoryDialog] = useState(false);
	const [aiTags, setAiTags] = useState<any[]>([]);
	const refetch = useRefresh();

	useEffect(() => {
		getAiTags();
	}, []);
	const getAiTags = useCallback(async () => {
		try {
			const response = await axios.get(`${constants.API_URL}aitag`, {
				
			});
		if(response.data){
			if(response.data?.data && response.data.data.length > 0){
				setAiTags(response.data.data);
			}
			
		}
		
			
		} catch (error) {
			console.error('Error fetching ai tags:', error);
			notify(getLocalizedErrorMessage(error as AxiosError), { type: 'error' });
		}
	}, []);

	const notify = useNotify();
	return (
		<>
			<CreateProactiveItemCategoryDialog
				onClose={() => {
					setShowCreateCategoryDialog(false);
				}}
				onCreate={async (categoryName) => {
					try {
						await axios.post(`${constants.API_URL}/proactive/item/category`, {
							name: categoryName,
						});
						refetch();
						notify(`הקטגוריה ${categoryName} נוצרה בהצלחה`, { type: 'success' });
					} catch (error) {
						notify(`שגיאה ביצירת קטגוריה: ${getLocalizedErrorMessage(error as AxiosError)}`, {
							type: 'error',
						});
					}
				}}
				open={showCreateCategoryDialog}
			/>
			<Edit mutationMode="pessimistic">
				<SimpleForm dir="rtl">
					<div className="w-full">
						<div className="grid-cols-1 md:grid-cols-2 md:grid gap-4 mb-8">
							<h5 className="col-span-2 font-medium text-start">כותרת</h5>
							<TextInput
								source="title.he"
								label="עברית"
								fullWidth
								required
								margin="none"
								helperText={false}
							/>
							<TextInput
								source="title.en"
								label="אנגלית"
								fullWidth
								required
								margin="none"
								helperText={false}
							/>
						</div>

						<div className="grid-cols-1 md:grid-cols-2 md:grid gap-4 mb-8">
							<h5 className="col-span-2 font-medium text-start">כותרת משנה</h5>

							<TextInput source="sub_title.he" label="עברית" fullWidth helperText={false} />
							<TextInput source="sub_title.en" label="אנגלית" fullWidth helperText={false} />
						</div>
						<div className="grid-cols-1 md:grid-cols-2 md:grid gap-4 mb-8">
							<h5 className="col-span-2 font-medium text-start">טקסט קידום</h5>
							<TextInput source="promotion_text.he" label="עברית" fullWidth helperText={false} />
							<TextInput source="promotion_text.en" label="אנגלית" fullWidth helperText={false} />
						</div>
						<div className="grid-cols-1 md:grid-cols-2 grid gap-4 mb-8">
							<h5 className="col-span-2 font-medium text-start">תיאור</h5>
							<TextInput multiline source="description.he" label="עברית" fullWidth helperText={false} />
							<TextInput multiline source="description.en" label="אנגלית" fullWidth helperText={false} />
						</div>

						<div className="grid-cols-1 md:grid-cols-6 md:grid gap-4 mb-8">
							<h5 className="col-span-6 font-medium text-start">נתונים נוספים</h5>
							<TextInput className="col-span-2 w-full" source="url" label="URL" />
							<TextInput className="col-span-2 w-full" source="thumbnail" label="thumbnail" />
							<TextInput className="col-span-2 w-full" source="image" label="image" />
							<NumberInput source="points" label="נקודות" fullWidth required />
							<NumberInput source="duration" label="משך בשניות" fullWidth required />
							<BooleanInput source="is_global" label="פרוטקטיבי גלובלי" fullWidth />
							<BooleanInput source="is_program_boost" label="בוסט לתכנית" fullWidth />
							{/* GH-643: vertical full-screen reels presentation in the app */}
							<BooleanInput source="is_reel" label="בוסט אנכי (Reels)" fullWidth />
							<TextInput
								source="slug"
								label="SLUG (מזהה ייחודי)"
								fullWidth
								required
								inputProps={{ style: { textTransform: 'uppercase' } }}
								helperText="UPPERCASE only"
							/>
							<SelectInput
								className="col-span-1"
								margin="none"
								source="type"
								optionText={'label'}
								choices={[
									{ id: 'spotify', label: 'Spotify' },
									{ id: 'ted', label: 'TED' },
									{ id: 'video', label: 'video' },
								]}
								label="סוג תוכן"
								fullWidth
								required
							/>
							<BooleanInput source="active" label="פעיל" fullWidth />
						</div>
					</div>
					<div className="flex flex-row gap-4 items-center">
						<ReferenceInput
							reference="proactive/item/category"
							perPage={999}
							source="category"
							label="קטגוריה"
						>
							<SelectInput optionText={'name'} helperText={false} />
						</ReferenceInput>
						<Button
							onClick={() => {
								setShowCreateCategoryDialog(true);
							}}
						>
							צור קטגוריה חדשה
						</Button>
					</div>
					<VideoUploadInput source="video" disabled />

					<Grid item xs={2}>
							<SelectArrayInput
								source="ai_tags"
								label="תגיות AI"
								choices={aiTags.map((tag: any) => ({
									id: tag._id || tag.id,
									name: `${tag.name} (${tag.english_name})`,
								}))}
								fullWidth
							/>
						</Grid>
				</SimpleForm>
			</Edit>
		</>
	);
};

export default ProactiveItemEdit;
